module.exports = __webpack_public_path__ + "static/media/filter-icon-reset-normal.3ea79895.svg";